import { useSearchParams } from 'react-router-dom';

import { FilterConfig } from '@/types/filters';

export type FilterValues = {
  values: Record<string, string | string[]>;
  isEmpty: boolean;
};

export function useFilterValues(config: FilterConfig[]): FilterValues {
  const [searchParams] = useSearchParams();

  const values: Record<string, string | string[]> = {};

  for (const [key, value] of searchParams.entries()) {
    // only include keys that exist in config
    if (config.some(c => c.name === key)) {
      const allValues = searchParams.getAll(key);
      values[key] = allValues.length > 1 ? allValues : value;
    }
  }

  const isEmpty = Object.keys(values).length === 0;

  return { values, isEmpty };
}
